import { httpRequest } from "@/axios/axios-api";

export default {
  name: "LiveCourseList",
  data() {
    return {
      majorId: "",
      liveList: [],
      currentPage: 1,
      pageSize: 6,
      defaultThumb: require("@/assets/live_default_thumb.png")
    };
  },
  computed: {
    pagedLiveList() {
      const start = (this.currentPage - 1) * this.pageSize;
      return this.liveList.slice(start, start + this.pageSize);
    }
  },
  created() {
    const rawMajorId = this.$route.query.majorId;
    this.majorId =
      rawMajorId === null || rawMajorId === undefined ? "" : rawMajorId;
    this.loadLiveList();
  },
  methods: {
    async loadLiveList() {
      const loadingInstance = this.$loading({ text: "加载中" });
      const res = await httpRequest("/app/course/live/courses", "get", {
        majorId: this.majorId
      });
      if (res && res.code === 200 && Array.isArray(res.data)) {
        this.liveList = res.data;
      } else {
        this.liveList = [];
      }
      this.currentPage = 1;
      loadingInstance.close();
    },
    handlePageChange(page) {
      this.currentPage = page;
    },
    go2LivePage(live) {
      if (!live || !live.liveUrl) {
        this.$message.warning("直播地址无效");
        return;
      }
      window.open(live.liveUrl, "_blank");
    }
  }
};
